import { updateProviderSchedule } from '@uplift/api';
import { useQueryClient, useMutation as useMutationRQ } from '@tanstack/react-query';


export const useUpdateIdealCaseload = () => {
  const queryClient = useQueryClient();

  const mutation = useMutationRQ(async (args: { caseload: number; userId: string }) => {
    await updateProviderSchedule(args.userId, { idealCaseload: args.caseload });
  }, {
    async onSuccess(_data, variables) {
      await queryClient.invalidateQueries([ 'provider', variables.userId, 'schedule' ]);
    },
  });

  return mutation.mutateAsync;
};
